<template>
    <div class="rating-avatar">
        <div class="rating-avatar__pie">
            <common-rating-pie :rating="rating" :size="size"></common-rating-pie>
        </div>
        <div class="rating-avatar__avatar">
            <common-ancillary-avatar v-if="showPracticeAvatar && user" :ancillary="user" :size="size"></common-ancillary-avatar>
            <common-user-avatar
                v-else
                :user="user"
                :size="size"
                :isUserProfileLinkEnabled="isUserProfileLinkEnabled"
            ></common-user-avatar>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            rating: { type: Number, default: undefined },
            user: { type: Object, default: undefined },
            size: { type: String, default: 'member-switch' },
            isUserProfileLinkEnabled: { type: Boolean, default: true },
            showPracticeAvatar: { type: Boolean, default: false },
        },
    }
</script>
